import axios from 'axios';
import { oidcAccessTokenExists } from '../services/oidc';
import { loadOidcAccessToken } from '../services/oidc';

const api = axios.create({ baseURL: process.env.REACT_APP_APIMAN_URL });

api.interceptors.request.use(requestHandler, errorHandler);

function requestHandler(request) {
  if (oidcAccessTokenExists()) {
    request.headers['Authorization'] = `Bearer ${loadOidcAccessToken()}`;
  }
  request.headers['Content-type'] = 'application/json';
  if (request.url.indexOf('?') >= 0) {
    request.url += `&apikey=${process.env.REACT_APP_APIKEY}`;
  }
  else request.url += `?apikey=${process.env.REACT_APP_APIKEY}`;
  return request;
};

api.interceptors.response.use(responseHandler, errorHandler);

function responseHandler(response) {
  return response;
};

function errorHandler(error) {
  console.error(error);
  return Promise.reject(error);
};

export default api;
